import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiResponse } from "../../models/api-response.model";
import { ApiService } from "../api.service";

@Injectable({ providedIn: 'root' })
export class AuthApi {

  constructor(private api: ApiService) { }


  // login via password
  login(email: string, password: string, clientInfo: any) {
    return this.api.post<{ success: boolean; message: string; data: any }>('/auth/login-password', { email, password, clientInfo });
  }

  // check identity or user
  identify(email: string) {
    return this.api.post<{ success: boolean; message: string; data: any }>('/auth/identify', { email });
  }

  logOut(): Observable<ApiResponse> {
    return this.api.post<ApiResponse>('/auth/logout', {});
  }

  userMe(): Observable<ApiResponse> {
    return this.api.get<ApiResponse>('/users/me');
  }

  // change password
  changePassword(payload: { oldPassword: string; newPassword: string; }): Observable<ApiResponse> {
    return this.api.patch<ApiResponse>('/auth/change-password', payload);
  }

  sendForgotPasswordLink(payload: any) {
    return this.api.post<ApiResponse>(
      '/auth/send-link-forgot-password',
      payload
    );
  }

  /** Validate invitation token */
  validateInvite(token: string, from: string = ''): Observable<ApiResponse> {
    const params = {
      token,
      from
    };
    return this.api.get<ApiResponse>(
      '/auth/reset-password-link/validate',
      params
    );
    //return this.api.get<ApiResponse>(`/auth/reset-password-link/validate?token=${token}`);
  }

  resetPassword(payload: any): Observable<ApiResponse> {
    return this.api.post<ApiResponse>('/auth/reset-password', payload);
  }

  getSessions() {
    return this.api.get<any>('/auth/sessions');
  }

  logoutSession(id: string) {
    return this.api.delete<any>('/auth/sessions/' + id);
  }

  logoutOthers() {
    return this.api.delete<any>('/auth/sessions/logout-others');
  }
}
